import { FocalPoint } from "../../../schemas/Media";
const focalPointToCssMap = {
    [FocalPoint.RIGHT]: "right",
    [FocalPoint.LEFT]: "left",
    [FocalPoint.CENTER]: "center",
    [FocalPoint.TOP]: "top",
    [FocalPoint.BOTTOM]: "bottom",
};
export const focalPointToCss = (f) => (f ? focalPointToCssMap[f] : "center");
const focalPointToOffsetMap = {
    [FocalPoint.RIGHT]: { offsetX: 100 },
    [FocalPoint.LEFT]: { offsetX: 0 },
    [FocalPoint.CENTER]: {},
    [FocalPoint.TOP]: { offsetY: 0 },
    [FocalPoint.BOTTOM]: { offsetY: 100 },
};
export const focalPointToOffset = (f) => (f ? focalPointToOffsetMap[f] : {});
//# sourceMappingURL=focalPoint.js.map